import sepaIconV2Svg from './svg/sepaIconV2.svg?url';

export interface ISepaIconV2Props {
	size?: number;
}

export const SepaIconV2 = ({ size = 24 }: ISepaIconV2Props) => {
	return <img src={sepaIconV2Svg} alt="Klarna" width={size} height={size} />;
};
